import { render, staticRenderFns } from "./LowProfitQuotes.vue?vue&type=template&id=2feea9c0&scoped=true"
import script from "./LowProfitQuotes.vue?vue&type=script&lang=js"
export * from "./LowProfitQuotes.vue?vue&type=script&lang=js"
import style0 from "./LowProfitQuotes.vue?vue&type=style&index=0&id=2feea9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feea9c0",
  null
  
)

export default component.exports